import * as React from 'react';
import { Box } from '@mui/material';

import { AUTH_LAYOUT_FOOTER_HEIGHT } from 'consts';

interface AuthFooterLayoutProps {
  height?: number;
}

export const AuthFooterLayout: React.FC<AuthFooterLayoutProps> = (props) => {
  const { height = AUTH_LAYOUT_FOOTER_HEIGHT } = props;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        height,
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: height,
            height,
            background: 'linear-gradient(45deg, #FF8900 0%, #FF8900 50%, transparent 50%)',
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            left: height * 0.5,
            top: 0,
            width: `calc(100vw - ${height * 0.5}px)`,
            height,
            background: 'linear-gradient(45deg, transparent 48px, #FFA922 48px, #FFA922 100%);',
          }}
        />
      </Box>
    </Box>
  );
};
